import { InjectionToken, Injector, Directive, TemplateRef, Inject, Self, ChangeDetectorRef, Component, ChangeDetectionStrategy, ContentChild, ViewChild, Input, Pipe, NgModule } from '@angular/core';
import { NgComponentOutlet, CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Use this token to access context within your components when
 * instantiating them through {\@link PolymorpheusOutletComponent}
 * @type {?}
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["polymorpheus-outlet", ""];
function PolymorpheusOutletComponent_ng_container_0_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 5);
    ɵngcc0.ɵɵpipe(1, "injector");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngComponentOutlet", ctx_r4.content.component)("ngComponentOutletInjector", ɵngcc0.ɵɵpipeBind2(1, 2, ctx_r4.content, ctx_r4.proxy));
} }
function PolymorpheusOutletComponent_ng_container_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, PolymorpheusOutletComponent_ng_container_0_ng_template_1_ng_container_0_Template, 2, 5, "ng-container", 4);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.guard(ctx_r3.content));
} }
function PolymorpheusOutletComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 2);
    ɵngcc0.ɵɵtemplate(1, PolymorpheusOutletComponent_ng_container_0_ng_template_1_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(2);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.getTemplate(ctx_r0.content, _r2))("ngTemplateOutletContext", ctx_r0.context);
} }
function PolymorpheusOutletComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.primitive);
} }
const _c1 = function (a0) { return { $implicit: a0 }; };
function PolymorpheusOutletComponent_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 2);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r7.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r7.primitive));
} }
function PolymorpheusOutletComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PolymorpheusOutletComponent_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(2, PolymorpheusOutletComponent_ng_container_1_ng_template_2_Template, 1, 4, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.template)("ngIfElse", _r6);
} }
const POLYMORPHEUS_CONTEXT = new InjectionToken('Context from polymorpheus-outlet');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Wrapper class for a component that will be used as content for {\@link PolymorpheusOutletComponent}
 *
 * @param component — an Angular component to be dynamically created
 * @param injector — optional {\@link Injector} for lazy loaded module case
 * @template T, C
 */
class PolymorpheusComponent {
    /**
     * @param {?} component
     * @param {?=} injector
     */
    constructor(component, injector = null) {
        this.component = component;
        this.injector = injector;
    }
    /**
     * @param {?} injector
     * @param {?} context
     * @return {?}
     */
    createInjector(injector, context) {
        return Injector.create({
            parent: this.injector || injector,
            providers: [
                {
                    provide: POLYMORPHEUS_CONTEXT,
                    useValue: context,
                },
            ],
        });
    }
}
if (false) {
    /** @type {?} */
    PolymorpheusComponent.prototype.component;
    /**
     * @type {?}
     * @private
     */
    PolymorpheusComponent.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ng-template wrapper directive also stores {\@link ChangeDetectorRef} to properly handle change detection.
 * @template C
 */
class PolymorpheusTemplate {
    /**
     * @param {?} template
     * @param {?} changeDetectorRef
     */
    constructor(template, changeDetectorRef) {
        this.template = template;
        this.changeDetectorRef = changeDetectorRef;
        this.polymorpheus = '';
    }
    /**
     * @return {?}
     */
    check() {
        this.changeDetectorRef.markForCheck();
    }
    /**
     * @template T
     * @param {?} _dir
     * @param {?} _ctx
     * @return {?}
     */
    static ngTemplateContextGuard(_dir, _ctx) {
        return true;
    }
}
PolymorpheusTemplate.ɵfac = function PolymorpheusTemplate_Factory(t) { return new (t || PolymorpheusTemplate)(ɵngcc0.ɵɵdirectiveInject(TemplateRef, 2), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef)); };
PolymorpheusTemplate.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PolymorpheusTemplate, selectors: [["ng-template", "polymorpheus", ""]], inputs: { polymorpheus: "polymorpheus" }, exportAs: ["polymorpheus"] });
/** @nocollapse */
PolymorpheusTemplate.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Inject, args: [TemplateRef,] }, { type: Self }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PolymorpheusTemplate, [{
        type: Directive,
        args: [{
                selector: 'ng-template[polymorpheus]',
                exportAs: 'polymorpheus',
                inputs: ['polymorpheus']
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Inject,
                args: [TemplateRef]
            }, {
                type: Self
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }]; }, null); })();
if (false) {
    /** @type {?} */
    PolymorpheusTemplate.prototype.polymorpheus;
    /** @type {?} */
    PolymorpheusTemplate.prototype.template;
    /**
     * @type {?}
     * @private
     */
    PolymorpheusTemplate.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Outlet instantiating {\@link PolymorpheusContent} with given context
 * @template C
 */
class PolymorpheusOutletComponent {
    constructor() {
        this.template = null;
        this.content = null;
    }
    /**
     * @return {?}
     */
    get primitive() {
        if (!this.content || this.isAdvanced(this.content)) {
            return '';
        }
        return typeof this.content === 'function'
            ? this.content(this.context)
            : this.content;
    }
    /**
     * @param {?} content
     * @return {?}
     */
    isAdvanced(content) {
        return isTemplate(content) || isComponent(content);
    }
    /**
     * @param {?} content
     * @param {?} componentTmp
     * @return {?}
     */
    getTemplate(content, componentTmp) {
        if (isComponent(content)) {
            return componentTmp;
        }
        return isDirective(content) ? content.template : content;
    }
    /**
     * @param {?} content
     * @return {?}
     */
    guard(content) {
        return isComponent(content);
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    ngOnChanges({ content, context }) {
        if (context && this.proxy === undefined) {
            this.proxy =
                typeof this.context === 'object' && !Array.isArray(this.context)
                    ? new Proxy(this.context, {
                        get: (_, key) => this.context[(/** @type {?} */ (key))],
                    })
                    : this.context;
        }
        // TODO: Keep an eye on private field, name can change
        /** @type {?} */
        const componentRef = (/** @type {?} */ ((!content &&
            context &&
            this.outlet &&
            this.outlet['_componentRef'])));
        if (componentRef) {
            componentRef.injector.get(ChangeDetectorRef).markForCheck();
        }
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        if (isDirective(this.content)) {
            this.content.check();
        }
    }
}
PolymorpheusOutletComponent.ɵfac = function PolymorpheusOutletComponent_Factory(t) { return new (t || PolymorpheusOutletComponent)(); };
PolymorpheusOutletComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PolymorpheusOutletComponent, selectors: [["", "polymorpheus-outlet", ""]], contentQueries: function PolymorpheusOutletComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, viewQuery: function PolymorpheusOutletComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgComponentOutlet, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.outlet = _t.first);
    } }, inputs: { content: "content", context: "context" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c0, decls: 2, vars: 2, consts: [[3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["component", ""], [3, "ngComponentOutlet", "ngComponentOutletInjector", 4, "ngIf"], [3, "ngComponentOutlet", "ngComponentOutletInjector"], [4, "ngIf", "ngIfElse"], ["child", ""]], template: function PolymorpheusOutletComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PolymorpheusOutletComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, PolymorpheusOutletComponent_ng_container_1_Template, 4, 2, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAdvanced(ctx.content));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.primitive);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgComponentOutlet]; }, pipes: function () { return [InjectorPipe]; }, encapsulation: 2, changeDetection: 0 });
PolymorpheusOutletComponent.propDecorators = {
    template: [{ type: ContentChild, args: [TemplateRef,] }],
    outlet: [{ type: ViewChild, args: [NgComponentOutlet,] }],
    content: [{ type: Input }],
    context: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PolymorpheusOutletComponent, [{
        type: Component,
        args: [{
                selector: '[polymorpheus-outlet]',
                template: "<ng-container\n    *ngIf=\"isAdvanced(content)\"\n    [ngTemplateOutlet]=\"getTemplate(content, component)\"\n    [ngTemplateOutletContext]=\"context\"\n>\n    <ng-template #component>\n        <ng-container\n            *ngIf=\"guard(content)\"\n            [ngComponentOutlet]=\"content.component\"\n            [ngComponentOutletInjector]=\"content | injector : proxy\"\n        ></ng-container>\n    </ng-template>\n</ng-container>\n<ng-container *ngIf=\"primitive\">\n    <ng-container *ngIf=\"!template; else child\">{{primitive}}</ng-container>\n    <ng-template #child>\n        <ng-container\n            [ngTemplateOutlet]=\"template\"\n            [ngTemplateOutletContext]=\"{$implicit: primitive}\"\n        ></ng-container>\n    </ng-template>\n</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { template: [{
            type: ContentChild,
            args: [TemplateRef]
        }], content: [{
            type: Input
        }], outlet: [{
            type: ViewChild,
            args: [NgComponentOutlet]
        }], context: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    PolymorpheusOutletComponent.prototype.template;
    /** @type {?} */
    PolymorpheusOutletComponent.prototype.outlet;
    /** @type {?} */
    PolymorpheusOutletComponent.prototype.proxy;
    /** @type {?} */
    PolymorpheusOutletComponent.prototype.content;
    /** @type {?} */
    PolymorpheusOutletComponent.prototype.context;
}
/**
 * @template C
 * @param {?} content
 * @return {?}
 */
function isDirective(content) {
    return content instanceof PolymorpheusTemplate;
}
/**
 * @template C
 * @param {?} content
 * @return {?}
 */
function isComponent(content) {
    return content instanceof PolymorpheusComponent;
}
/**
 * @template C
 * @param {?} content
 * @return {?}
 */
function isTemplate(content) {
    return isDirective(content) || content instanceof TemplateRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Internal use {\@link Pipe} to create {\@link Injector}
 * only when either content or context change
 * @template C
 */
class InjectorPipe {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        this.injector = injector;
    }
    /**
     * @param {?} content
     * @param {?} context
     * @return {?}
     */
    transform(content, context) {
        return content.createInjector(this.injector, context);
    }
}
InjectorPipe.ɵfac = function InjectorPipe_Factory(t) { return new (t || InjectorPipe)(ɵngcc0.ɵɵdirectiveInject(Injector, 16)); };
InjectorPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "injector", type: InjectorPipe, pure: true });
/** @nocollapse */
InjectorPipe.ctorParameters = () => [
    { type: Injector, decorators: [{ type: Inject, args: [Injector,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InjectorPipe, [{
        type: Pipe,
        args: [{
                name: 'injector'
            }]
    }], function () { return [{ type: ɵngcc0.Injector, decorators: [{
                type: Inject,
                args: [Injector]
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    InjectorPipe.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PolymorpheusModule {
}
PolymorpheusModule.ɵfac = function PolymorpheusModule_Factory(t) { return new (t || PolymorpheusModule)(); };
PolymorpheusModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PolymorpheusModule });
PolymorpheusModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PolymorpheusModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [PolymorpheusOutletComponent, PolymorpheusTemplate, InjectorPipe],
                exports: [PolymorpheusOutletComponent, PolymorpheusTemplate]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PolymorpheusModule, { declarations: function () { return [PolymorpheusOutletComponent, PolymorpheusTemplate, InjectorPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PolymorpheusOutletComponent, PolymorpheusTemplate]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { POLYMORPHEUS_CONTEXT, PolymorpheusComponent, PolymorpheusModule, PolymorpheusOutletComponent, PolymorpheusTemplate, InjectorPipe as ɵa };

